export const AdminMenus = [
  {
    id: 1,
    name: 'Dashboard',
    icon: 'bi bi-speedometer2',
    link: '/admin',
  },
  {
    id: 2,
    name: 'Leagues',
    icon: 'bi bi-trophy',
    link: '/admin-league',
  },
  {
    id: 3,
    name: 'Game Rooms',
    icon: 'bi bi-controller',
    link: '/admin-create-game-room',
    subItem: [
      {
        id: 31,
        name: 'Create',
        link: '/admin-create-game-room',
      },
      {
        id: 32,
        name: 'List',
        link: '/admin-game-room-list',
      },
      {
        id: 33,
        name: 'My Games',
        link: '/admin-my-games',
      },
    ],
  },
  {
    id: 4,
    name: 'PlayerTransferValue',
    icon: 'bi bi-arrow-down-up',
    link: '/player-transfer-value',
  },
  {
    id: 7,
    name: 'Balances',
    icon: 'bi bi-wallet2',
    link: '/admin-balances',
  },
  {
    id: 5,
    name: 'Notification',
    icon: 'bi bi-bell',
    link: '/admin-notification',
  },
  {
    id: 6,
    name: 'Log out',
    icon: 'bi bi-box-arrow-right',
    link: '/logout',
  },
]
